<template>
    <a-drawer
        :title="dataInfo.name"
        :visible="visible"
        :width="width"
        placement="right"
        @close="handleClose"
    >
        <div class="title strong mb20">活动信息</div>
        <a-row :gutter="[10,10]">
            <a-col :span="12">
                活动名称：{{ dataInfo.name }}
            </a-col>
            <a-col :span="12">
                促销状态：<!--status == 0 ？暂停 ：进行中-->
                <a-tag color="green" v-if="dataInfo.status == 1">进行中</a-tag>
                <a-tag color="red" v-if="dataInfo.status == 0">已暂停</a-tag>
            </a-col>
            <a-col :span="14">
                起止时间：{{ dataInfo.start_time }} ~ {{ dataInfo.end_time }}
            </a-col>
        </a-row>

        <div class="title strong mb20 mt20">门票信息</div>
        <a-table
            ref="table"
            :rowKey="(record) => record.id"
            :columns="columns"
            :data-source="dataInfo.goods"
            :pagination="false"
            class="mt15" size="middle"
        >
            <span slot="index" slot-scope="text, record, index">
                {{index + 1}}
            </span>
            <span slot="status" slot-scope="text">
                <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
            </span>

            <span slot="inventory" slot-scope="text, record">
                {{ record.is_limit == 0 ? '不限' : text }}
            </span>

            <span slot="action" slot-scope="text, record">
                {{ record.promo_price }} 元
            </span>
        </a-table>
    </a-drawer>
</template>

<script>
export default {
    name: "LadderInfo",
    props : {
        dataInfo : {
            type: Object,
            default: () => {
            }
        },
        width: {
            type: Number,
            default: 800
        },
        visible : {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            columns:[
                {
                    title : '序号',
                    dataIndex : 'index',
                    align : 'center',
                    scopedSlots: { customRender: 'index' },
                },
                {
                    title : '门票名称',
                    dataIndex: 'name',
                    align : 'center',
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                    align: 'align'
                },
                {
                    title: '门票编号',
                    dataIndex: 'number',
                    align: 'align'
                },
                {
                    title: '库存',
                    dataIndex: 'inventory',
                    align : 'center',
                    scopedSlots: { customRender: 'inventory' },
                },
                {
                    title: '优惠后价格',
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            dataSource : []
        }
    },
    methods : {
        handleClose(){
            this.$emit('close');
        }
    },
}
</script>

<style scoped lang="less">

</style>